import { getHours as c } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getHours.js";
import { throwError as b } from "../../_utils/naive/warn.js";
const p = {
  amHours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"],
  pmHours: ["12", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"],
  hours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
  minutes: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
  seconds: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
  period: ["AM", "PM"]
};
function f(e) {
  return `00${e}`.slice(-2);
}
function N(e, m, u) {
  return Array.isArray(m) ? (u === "am" ? m.filter((r) => r < 12) : u === "pm" ? m.filter((r) => r >= 12).map((r) => r === 12 ? 12 : r - 12) : m).map((r) => f(r)) : typeof m == "number" ? u === "am" ? e.filter((r) => {
    const n = Number(r);
    return n < 12 && n % m === 0;
  }) : u === "pm" ? e.filter((r) => {
    const n = Number(r);
    return n >= 12 && n % m === 0;
  }).map((r) => {
    const n = Number(r);
    return f(n === 12 ? 12 : n - 12);
  }) : e.filter((r) => Number(r) % m === 0) : u === "am" ? e.filter((r) => Number(r) < 12) : u === "pm" ? e.map((r) => Number(r)).filter((r) => Number(r) >= 12).map((r) => f(r === 12 ? 12 : r - 12)) : e;
}
function d(e, m, u) {
  return u ? typeof u == "number" ? e % u === 0 : u.includes(e) : !0;
}
function g(e, m, u) {
  const r = N(p[m], u).map(Number);
  let n, o;
  for (let i = 0; i < r.length; ++i) {
    const t = r[i];
    if (t === e)
      return t;
    if (t > e) {
      o = t;
      break;
    }
    n = t;
  }
  return n === void 0 ? (o || b("time-picker", "Please set 'hours' or 'minutes' or 'seconds' props"), o) : o === void 0 || o - e > e - n ? n : o;
}
function y(e) {
  return c(e) < 12 ? "am" : "pm";
}
export {
  g as findSimilarTime,
  y as getAmPm,
  f as getFixValue,
  N as getTimeUnits,
  d as isTimeInStep,
  p as time
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/time-picker/src/utils.js
// module id = 936
// module chunks = 41